

import Vue from 'vue'
import states from '../helpers/states'
import format from 'date-fns/format'
import isFuture from 'date-fns/is_future'
import distanceInWordsStrict from 'date-fns/distance_in_words_strict'
import deLocale from 'date-fns/locale/de'

export default Vue.extend({
    props: {
        state: {
            type: Object,
        },
        props: {
            type: Object,
            default: () => ({})
        },
        listId: {
            type: String
        }
    },
    computed: <any>{
        isPaused() {
            if(!this.state.pausedUntil) return false
            return isFuture(this.state.pausedUntil)
        },
        stateDef() {
            return states[this.state.key]
        },
        isPermanentlyPaused() {
            return this.state.pausedUntil.startsWith('2100-01-01')
        },
        dateFormatted() {
            return distanceInWordsStrict(new Date, this.state.pausedUntil, {
                addSuffix: true,
                locale: deLocale
            })
        }
    }
})
